import { GENERAL_URL_API } from "../urls";

export const fetchConexionesSaml = async () => {
  const fd = new FormData();
  const res = await fetch(`${GENERAL_URL_API}/verDatos/verConexionesSAML.php`, {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  return res.json();
};

export const fetchConexionSaml = async (idInstitutoSAML) => {
  const fd = new FormData();
  fd.append("idInstitutoSAML", idInstitutoSAML);
  const res = await fetch(`${GENERAL_URL_API}/clientes/verConexionSAML.php`, {
    method: "POST",
    credentials: "include",
    body: fd,
  });
  return res.json();
};
